import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { AuthService } from '../../../../../../core';
import { UsuarioPerfil } from '../../../../../usuario/usuario-perfil';
import { CampanhaAnaliseAuthGuardService } from '../../../analise';
import { CampanhaOptions, CampanhaOptionsActions } from '../../../campanha-options';
import { CampanhaSearch } from '../../../campanha-search';
import { CampanhaEncerramentoAuthGuardService } from '../../../encerramento';
import { CampanhaAuthGuardService } from '../../../services';
import { CampanhaPedidoAuthGuardService } from '../../../pedidos/services';
import { CampanhaPipelineCard } from './campanha-pipeline-card';
import { CampanhaFilter } from '../../../filter';

interface Config {
    isSemCampanha: boolean;
}

@Component({
    selector: 'sgt-campanha-pipeline-card',
    templateUrl: './campanha-pipeline-card-component.html',
    styleUrls: ['./campanha-pipeline-card-component.less']
})
export class CampanhaPipelineCardComponent implements OnInit {
    config: Config;
    perfilUsuario: UsuarioPerfil;
    idUsuario: number;

    // Status das campanhas
    @Input() listIndex: number;
    @Input() listColor: string;
    @Input() isStatusNaoConfirmada: boolean;
    @Input() isStatusEmAnalise: boolean;
    @Input() isStatusEmAnamento: boolean;
    @Input() isStatusReprovada: boolean;
    @Input() isStatusEmRevisao: boolean;
    @Input() isStatusEncerrada: boolean;

    // Options
    @Input() draggable = false; // Se o card pode ser movido através do drag and drop
    @Input() optionsVisibility: CampanhaOptionsActions;
    options: CampanhaOptions;


    /** Campanha */
    @Input() entity: CampanhaSearch;
    /** Filtro das campanhas */
    @Input() filter: CampanhaFilter;

    // Eventos
    @Output() edit = new EventEmitter<CampanhaSearch>();
    @Output() visualizar = new EventEmitter<CampanhaSearch>();
    @Output() delete = new EventEmitter<CampanhaSearch>();
    // Análise
    @Output() solicitarAnalise = new EventEmitter<CampanhaSearch>();
    @Output() aprovarAnalise = new EventEmitter<CampanhaSearch>();
    @Output() reprovarAnalise = new EventEmitter<CampanhaSearch>();
    // Encerramento
    @Output() encerrar = new EventEmitter<CampanhaSearch>();
    // Pedidos
    @Output() liberarPedidos = new EventEmitter<CampanhaSearch>();

    // Collapse
    @ViewChild('collapse') collapse: ElementRef;
    @Input() isCollapseOpenDefaut = false;

    constructor(private authService: AuthService,
                private campanhaAuthGuardService: CampanhaAuthGuardService,
                private campanhaAnaliseAuthGuardService: CampanhaAnaliseAuthGuardService,
                private campanhaEncerramentoAuthGuardService: CampanhaEncerramentoAuthGuardService,
                private campanhaPedidoAuthGuardService: CampanhaPedidoAuthGuardService) { }

    ngOnInit(): void {
        this.perfilUsuario = this.authService.getPerfilUsuario();
        this.idUsuario = this.authService.getIdUsuario();

        // Se ainda não tiver o objeto do card
        if (!this.entity?.pipelineCard) {
            this.entity.pipelineCard = new CampanhaPipelineCard();
        }

        this.setConfig();
        this.createOptions();
    }

    private setConfig() {
        if (!this.entity) {
            return;
        }

        this.config = {
            isSemCampanha: this.entity.id === -1
        };
    }

    /** Cria as opções do card */
    private createOptions() {
        this.options = new CampanhaOptions();
        // Edit
        this.options.canEdit = this.optionsVisibility?.canEdit && this.campanhaAuthGuardService.canEdit(this.entity.id, this.entity.status, this.entity.idUsuarioCreated);
        // Visualizar
        this.options.canVisualizar = this.optionsVisibility?.canVisualizar && this.campanhaAuthGuardService.canVisualizar();

        /** Análise */
        // Solicitar Análise
        this.options.canSolicitarAnalise = this.optionsVisibility?.canSolicitarAnalise && this.campanhaAnaliseAuthGuardService.canSolicitar(this.entity.id, this.entity.status, this.entity.idUsuarioCreated);
        // Aprovar Análise
        this.options.canAprovarAnalise = this.optionsVisibility?.canAprovarAnalise && this.campanhaAnaliseAuthGuardService.canEnviar(this.entity.id, this.entity.status, this.entity.resultado?.quantidadePedidosVendasNaoLiberados ?? 0, this.entity.resultado?.quantidadePedidosBonificacoesNaoLiberados ?? 0);
        // Reprovar Análise
        this.options.canReprovarAnalise = this.optionsVisibility?.canReprovarAnalise && this.campanhaAnaliseAuthGuardService.canEnviar(this.entity.id, this.entity.status, this.entity.resultado?.quantidadePedidosVendasNaoLiberados ?? 0, this.entity.resultado?.quantidadePedidosBonificacoesNaoLiberados ?? 0);

        /** Encerramento */
        // Encerrar
        this.options.canEncerrar = this.optionsVisibility?.canEncerrar && this.campanhaEncerramentoAuthGuardService.canEncerrar(this.entity.id, this.entity.status);

        /** Pedidos */
        // Liberar Pedidos
        this.options.canLiberarPedidos = this.optionsVisibility?.canLiberarPedidos && this.campanhaPedidoAuthGuardService.canLiberarPedidos(this.entity.id, this.entity.status, this.entity.resultado?.quantidadePedidosVendasNaoLiberados ?? 0, this.entity.resultado?.quantidadePedidosBonificacoesNaoLiberados ?? 0);

        // Excluir
        this.options.canDelete = this.optionsVisibility?.canDelete && this.campanhaAuthGuardService.canDelete(this.entity.id, this.entity.status, this.entity.resultado?.quantidadePedidosVendasNaoLiberados ?? 0, this.entity.resultado?.quantidadePedidosBonificacoesNaoLiberados ?? 0, this.entity.idUsuarioCreated);
    }

    /** Abre/Fecha o collapse do card */
    toggleCollapse() {
        if (!this.entity.pipelineCard?.isCollapseOpened) {
            this.openCollapse();
        } else {
            this.closeCollpase();
        }
    }

    /** Abre o collapse do card */
    openCollapse() {
        this.entity.pipelineCard.isCollapseOpened = true;
        (jQuery(this.collapse?.nativeElement) as any).collapse('show');
    }

    /** Fecha o collapse do card */
    closeCollpase() {
        this.entity.pipelineCard.isCollapseOpened = false;
        (jQuery(this.collapse?.nativeElement) as any).collapse('hide');
    }

    /** Emite evento para editar a campanha */
    editClick() {
        if (!this.options.canEdit) {
            return;
        }

        this.edit.emit(this.entity);
    }

    /** Emite evento para visualizar a campanha */
    visualizarClick() {
        if (!this.options.canVisualizar) {
            return;
        }

        this.visualizar.emit(this.entity);
    }

    /** Emite evento para solicitar a análise da campanha */
    solicitarAnaliseClick() {
        if (!this.options.canSolicitarAnalise) {
            return;
        }

        this.solicitarAnalise.emit(this.entity);
    }

    /** Emite evento para aprovar a análise da campanha */
    aprovarAnaliseClick() {
        if (!this.options.canAprovarAnalise) {
            return;
        }

        this.aprovarAnalise.emit(this.entity);
    }

    /** Emite evento para reprovar a análise da campanha */
    reprovarAnaliseClick() {
        if (!this.options.canReprovarAnalise) {
            return;
        }

        this.reprovarAnalise.emit(this.entity);
    }

    /** Emite evento para encerrar a campanha */
    encerrarClick() {
        if (!this.options.canEncerrar) {
            return;
        }

        this.encerrar.emit(this.entity);
    }

    /** Emite evento para excluir a campanha */
    deleteClick() {
        if (!this.options.canDelete) {
            return;
        }

        this.delete.emit(this.entity);
    }

    /** Emite evento para liberar os pedidos da campanha */
    liberarPedidosClick() {
        if (!this.options.canLiberarPedidos) {
            return;
        }

        this.liberarPedidos.emit(this.entity);
    }
}
